/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
/** @jsx jsx */
import React from "react"
import { jsx, Global } from "@emotion/core"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import { RESET_CSS } from "../styles/reset"
import { typography, IDENTITY, colors } from "../styles"

const Layout = ({ children, ...restProps }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  // Site layout wrapper
  return (
    <>
      <Global styles={[RESET_CSS, IDENTITY]} />
      <div {...restProps} css={{ backgroundColor: colors.BACKGROUND_WHITE }}>
        {children}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
